import { UsernameType } from 'libs/shared/src/lib/definitions/username-types';

export const environment = {
  production: false,
  projectId: '00000000-0000-0000-0000-000000000001',
  apiBaseUrl: 'https://dev.api.rappider.com',
  npmSearchApiUrl: 'https://api.npms.io/v2/search',
  stripePublishableKey: 'pk_test_51LpZfVFhItefV5kPUn4PURfG4M30WDTHJNvLMsq6yzzueY6rXlqn4dsujXPsGDQzVU9rc1NjKD81Ldw2Mnr9ND2S00W6WhAYwS',
  isRegistrationEnabled: true,
  googleFontApiUrl: 'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBnJmg-UoTB-0s_vVRc27CgWkEf00QbSsI',
  usernameType: UsernameType.Email,
  logActionsToConsole: false,
  maxTryCountForRecursiveAPICalls: 10,
  delayTimeForRecursiveApiCalls: 5000,
  maxDelayTimeForRecursiveApiCalls: 30000,
  delayTimeForNotificationApiCall: 180000,
  maxVisibleNotifications: 50,
  isNotificationPollingActive: true,
  delayTimeForDeployManagementInformationApiCall: 5000,
  successNotificationVisibilityDuration: 7500,
  maxNumberOfApiCallsForDeployInformation: 10,
  maxFileCount: 5,
  maxFileSize: 102400,
  livePreviewInformationFilePath: 'live_preview_info.json',
  projectIdOfTemplatesForRappider: '00000000-0000-0000-0000-000000000002',
  stripeProductionId: 'prod_RN0dIs72oJfGNy',
  stripePricingIdMonthly: 'price_1QURheHkRYsLvzKCRCuV0sRv',
  stripePricingIdYearly: 'price_1QURi6HkRYsLvzKCJYoIIXES',
  primitiveDataSchemaId: '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
  /* We will display a warning that this is a demo project and prevent datasource creation */
  demoProjectIds: ['2596cbc4-c2f5-4441-8b71-9a833735664e'],
  angular19NxCodeGenerationTemplateId: 'a008576c-3a1f-41eb-b3e3-9829b87e3cd8',
  loopback4CodeGenerationTemplateId: 'e7596fd3-4b7b-4b98-a7c9-aa6725e092a3',
  flutterCodeGenerationTemplateId: '2004e00e-767c-4e01-920e-e5dca0980275'
};
